"use client";
import React from "react";
export default function Icon(param) {
    var keyword = param.keyword, className = param.className;
    return /*#__PURE__*/ React.createElement(React.Fragment, null, keyword === "Thoughts" || keyword === "Create" ? /*#__PURE__*/ React.createElement("svg", {
        width: "18px",
        height: "18px",
        viewBox: "0 0 18 18",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-922.000000, -6258.000000)",
        fill: "#2C94B1"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Resources",
        transform: "translate(0.000000, 6117.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(0.000000, 130.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Secondary-Resources",
        transform: "translate(911.000000, 0.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon",
        transform: "translate(11.000000, 11.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M9,10.125 C9.621315,10.125 10.125,9.621315 10.125,9 C10.125,8.378685 9.621315,7.875 9,7.875 C8.378685,7.875 7.875,8.378685 7.875,9 C7.875,9.621315 8.378685,10.125 9,10.125 Z",
        id: "Path",
        fillRule: "nonzero"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M18,9 C18,13.9705875 13.9705875,18 9,18 C4.029435,18 0,13.9705875 0,9 C0,4.029435 4.029435,0 9,0 C13.9705875,0 18,4.029435 18,9 Z M12.375,4.5 L6.75,6.75 L4.5,12.375 L5.625,13.5 L11.25,11.25 L13.5,5.625 L12.375,4.5 Z",
        id: "Shape"
    })))))))) : null, keyword === "Video" || keyword === "Webinar" ? /*#__PURE__*/ React.createElement("svg", {
        width: "18px",
        height: "11px",
        viewBox: "0 0 18 11",
        version: "1.1",
        xmlns: "http://www.w3.org/2000/svg",
        className: className
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Homepage",
        transform: "translate(-922.000000, -6509.000000)",
        fill: "#2C94B1",
        fillRule: "nonzero"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Page/Resources",
        transform: "translate(0.000000, 6117.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Content",
        transform: "translate(0.000000, 130.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Secondary-Resources",
        transform: "translate(911.000000, 0.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Resource-Tile/Secondary",
        transform: "translate(0.000000, 247.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Icon",
        transform: "translate(11.000000, 15.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M0,0 L11.25,0 L11.25,11 L0,11 L0,0 Z M13.5,3.3 L16.875,0 L18,0 L18,11 L16.875,11 L13.5,7.7 L13.5,3.3 Z",
        id: "Combined-Shape"
    }))))))))) : null, keyword === "analytics" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Analytics"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Analytics",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M23.255814,0 L21.3953488,0 L21.3953488,18.6046512 L40,18.6046512 L40,16.744186 C40,7.49663256 32.5034419,0 23.255814,0 Z M16.744186,6.51162791 C7.49663256,6.51162791 0,14.0082605 0,23.255814 C0,32.5034419 7.49663256,40 16.744186,40 C25.991814,40 33.4883721,32.5034419 33.4883721,23.255814 L33.4883721,21.3953488 L18.6046512,21.3953488 L18.6046512,6.51162791 L16.744186,6.51162791 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "arrows" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Facillitate"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Benefits-Module:-Facillitate-Feature-Active",
        transform: "translate(-75.000000, -441.000000)",
        fill: "#2C94B1"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Benefits-Tabber",
        transform: "translate(75.000000, 240.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-facillitate_teal",
        transform: "translate(0.000000, 201.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M16.3636364,7.27272727 L16.3636364,18.1818182 L27.2727273,18.1818182 L27.2727273,25.4545455 L40,12.7272727 L27.2727273,0 L27.2727273,7.27272727 L16.3636364,7.27272727 Z M12.7272727,21.8181818 L23.6363636,21.8181818 L23.6363636,32.7272727 L12.7272727,32.7272727 L12.7272727,40 L0,27.2727273 L12.7272727,14.5454545 L12.7272727,21.8181818 Z",
        id: "Shape"
    })))))) : null, keyword === "cog" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Energy+Utility"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Energy+Utility",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M20,0 L14.5454545,5.45454545 L5.45454545,5.45454545 L5.45454545,14.5454545 L0,20 L5.45454545,25.4545455 L5.45454545,34.5454545 L14.5454545,34.5454545 L20,40 L25.4545455,34.5454545 L34.5454545,34.5454545 L34.5454545,25.4545455 L40,20 L34.5454545,14.5454545 L34.5454545,5.45454545 L25.4545455,5.45454545 L20,0 Z M20,27.2727273 C24.0165455,27.2727273 27.2727273,24.0165455 27.2727273,20 C27.2727273,15.9833818 24.0165455,12.7272727 20,12.7272727 C15.9833818,12.7272727 12.7272727,15.9833818 12.7272727,20 C12.7272727,24.0165455 15.9833818,27.2727273 20,27.2727273 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "connect" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "39px",
        viewBox: "0 0 40 39",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Connect"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Benefits-Module:-Connect-Feature-Active",
        transform: "translate(-75.000000, -240.000000)",
        fill: "#2C94B1"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-connect_teal",
        transform: "translate(75.000000, 240.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20,0 C16.4854545,0 13.6363636,2.84246512 13.6363636,6.34883721 C13.6363636,9.2248786 15.5532,11.6542702 18.1818182,12.43476 L18.1818182,21.729893 L10.0026,27.4420326 C8.97134545,26.723707 7.71681818,26.3023256 6.36363636,26.3023256 C2.84909091,26.3023256 0,29.1447907 0,32.6511628 C0,36.1575349 2.84909091,39 6.36363636,39 C9.87818182,39 12.7272727,36.1575349 12.7272727,32.6511628 C12.7272727,31.815293 12.5653636,31.0171535 12.2711273,30.2863116 L20,24.8887116 L27.7289091,30.2863116 C27.4345455,31.0171535 27.2727273,31.815293 27.2727273,32.6511628 C27.2727273,36.1575349 30.1218182,39 33.6363636,39 C37.1509091,39 40,36.1575349 40,32.6511628 C40,29.1447907 37.1509091,26.3023256 33.6363636,26.3023256 C32.2832727,26.3023256 31.0287273,26.723707 29.9974545,27.4420326 L21.8181818,21.729893 L21.8181818,12.43476 C24.4467273,11.6542702 26.3636364,9.2248786 26.3636364,6.34883721 C26.3636364,2.84246512 23.5145455,0 20,0 Z",
        id: "Path"
    }))))) : null, keyword === "deploy" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "36px",
        viewBox: "0 0 40 36",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Deploy"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Benefits-Module:-Deploy-Feature-Active",
        transform: "translate(-75.000000, -643.000000)",
        fill: "#2C94B1"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Benefits-Tabber",
        transform: "translate(75.000000, 240.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-deploy_teal",
        transform: "translate(0.000000, 403.000000)"
    }, /*#__PURE__*/ React.createElement("polygon", {
        id: "Path",
        points: "25.4545455 0 14.5454545 0 14.5454545 10.8 18.1818182 10.8 18.1818182 16.2 5.45454545 16.2 3.63636364 16.2 3.63636364 18 3.63636364 25.2 0 25.2 0 36 10.9090909 36 10.9090909 25.2 7.27272727 25.2 7.27272727 19.8 18.1818182 19.8 18.1818182 25.2 14.5454545 25.2 14.5454545 36 25.4545455 36 25.4545455 25.2 21.8181818 25.2 21.8181818 19.8 32.7272727 19.8 32.7272727 25.2 29.0909091 25.2 29.0909091 36 40 36 40 25.2 36.3636364 25.2 36.3636364 18 36.3636364 16.2 34.5454545 16.2 21.8181818 16.2 21.8181818 10.8 25.4545455 10.8"
    })))))) : null, keyword === "file" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "36px",
        height: "40px",
        viewBox: "0 0 36 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Spreadsheets"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Spreadsheets",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M23.0769231,0 L23.0769231,11.627907 L23.0769231,13.0232558 L24.4615385,13.0232558 L36,13.0232558 L36,40 L0,40 L0,0 L23.0769231,0 Z M25.8461538,0 L25.8461538,10.2325581 L36,10.2325581 L36,10.1197023 L25.9582154,0 L25.8461538,0 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "finance" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Financial Services"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Financial-Services",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M32.7272727,5 L0,5 L0,27.819316 L32.7272727,27.819316 L32.7272727,5 Z M40,10.385513 L40,12.180684 L40,33.204829 L40,35 L38.1818182,35 L7.27272727,35 L5.45454545,35 L5.45454545,31.409658 L7.27272727,31.409658 L36.3636364,31.409658 L36.3636364,12.180684 L36.3636364,10.385513 L40,10.385513 Z M16.3636364,20.6384526 C18.874,20.6384526 20.9090909,18.6291177 20.9090909,16.1505251 C20.9090909,13.6719505 18.874,11.6626515 16.3636364,11.6626515 C13.8532545,11.6626515 11.8181818,13.6719505 11.8181818,16.1505251 C11.8181818,18.6291177 13.8532545,20.6384526 16.3636364,20.6384526 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "forecast" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Forecast"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Forecast",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.71428571,0 L0,0 L0,3.80952381 L5.71428571,3.80952381 C22.5459048,3.80952381 36.1904762,17.4540952 36.1904762,34.2857143 L36.1904762,40 L40,40 L40,34.2857143 C40,15.3502286 24.6497143,0 5.71428571,0 Z M5.71428571,19.047619 L0,19.047619 L0,22.8571429 L5.71428571,22.8571429 C12.0261143,22.8571429 17.1428571,27.9739048 17.1428571,34.2857143 L17.1428571,40 L20.952381,40 L20.952381,34.2857143 C20.952381,25.8699048 14.1300571,19.047619 5.71428571,19.047619 Z M0,9.52380952 L5.71428571,9.52380952 C19.3899048,9.52380952 30.4761905,20.6100952 30.4761905,34.2857143 L30.4761905,40 L26.6666667,40 L26.6666667,34.2857143 C26.6666667,22.7140952 17.2859048,13.3333333 5.71428571,13.3333333 L0,13.3333333 L0,9.52380952 Z M10.4761905,29.5238095 L0,29.5238095 L0,40 L10.4761905,40 L10.4761905,29.5238095 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "graph" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Automate/Small"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Automate/Small",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M0,0 L1.81818182,0 L12.7272727,0 L12.7272727,3.63636364 L3.63636364,3.63636364 L3.63636364,12.7272727 L0,12.7272727 L0,1.81818182 L0,0 Z M36.3636364,3.63636364 L27.2727273,3.63636364 L27.2727273,0 L38.1818182,0 L40,0 L40,1.81818182 L40,12.7272727 L36.3636364,12.7272727 L36.3636364,3.63636364 Z M36.3636364,27.2727273 L36.3636364,36.3636364 L27.2727273,36.3636364 L27.2727273,40 L38.1818182,40 L40,40 L40,38.1818182 L40,27.2727273 L36.3636364,27.2727273 Z M3.63636364,36.3636364 L3.63636364,27.2727273 L0,27.2727273 L0,38.1818182 L0,40 L1.81818182,40 L12.7272727,40 L12.7272727,36.3636364 L3.63636364,36.3636364 Z M17.0807273,10.0959818 L15.5995455,7.13350909 L13.8954727,9.97363636 L8.97056364,18.1818182 L3.63636364,18.1818182 L3.63636364,21.8181818 L10,21.8181818 L11.0294364,21.8181818 L11.5590727,20.9354545 L15.3095455,14.6846727 L22.9192727,29.904 L24.4003636,32.8665455 L26.1045455,30.0263636 L31.0294545,21.8181818 L36.3636364,21.8181818 L36.3636364,18.1818182 L30,18.1818182 L28.9705455,18.1818182 L28.4409091,19.0645455 L24.6905455,25.3152727 L17.0807273,10.0959818 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "healthcare" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Healthcare"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Healthcare",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("polygon", {
        id: "Icon",
        fill: "#2C94B1",
        points: "40 9.31317166 30.6867536 0 28.0451457 2.64162662 31.3808715 5.97724037 27.7982071 9.55979272 18.5630396 0.324550544 15.9213756 2.96617716 19.2627613 6.30760013 15.9586779 9.6117208 22.7324167 16.385609 20.7513042 18.3667216 13.9774533 11.5929454 9.03531904 16.5350424 15.8089831 23.308669 13.8277585 25.2899684 7.0540944 18.5163417 4.5177249 21.0525991 4.5177249 32.8406485 0 37.3583921 2.64162662 40 7.15959434 35.4820696 18.9470833 35.4820696 33.6922318 20.7369212 37.0335613 24.0784376 39.6753561 21.4368296 30.439815 12.2014193 34.0224794 8.61888567 37.3583921 11.9547983"
    }))) : null, keyword === "manufacturing" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Manufacturing"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Manufacturing",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("polygon", {
        id: "Icon",
        fill: "#2C94B1",
        points: "0 0 14.5454545 0 14.5454545 18.6850909 27.2727273 11.4124 27.2727273 18.6850909 40 11.4124 40 40 11.8181818 40 11.8181818 30.9090909 6.36363636 30.9090909 6.36363636 40 0 40"
    }))) : null, keyword === "ops" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/MLOps"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/MLOps",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M15.9090909,0.418745455 C17.2296364,0.144254545 18.598,0 20,0 C24.9038182,0 29.3954545,1.76485455 32.8741818,4.69405455 L16.7029091,14.0306 C16.426,14.1839091 16.1607455,14.3559273 15.9090909,14.5449636 L15.9090909,0.418745455 Z M22.6801818,13.7287818 L34.9089091,6.66847273 C38.0749091,10.2066364 40,14.8785091 40,20 C40,21.1932727 39.8954545,22.362 39.6950909,23.4978182 L23.5021818,14.1488 C23.2390909,13.9910545 22.9647273,13.8505273 22.6801818,13.7287818 Z M26.77,19.1845455 C26.8018182,19.452 26.8181818,19.724 26.8181818,20 L26.8181818,38.8076364 C32.5676364,36.7229091 37.0894545,32.0769091 39.0045455,26.2483636 L26.77,19.1845455 Z M0.304909091,16.5018182 C0.104527273,17.6376364 0,18.8065455 0,20 C0,25.1214545 1.92501818,29.7932727 5.09096364,33.3314545 L17.3198182,26.2712727 C17.0289091,26.1467273 16.7485455,26.0025455 16.4801818,25.8405455 L0.304909091,16.5018182 Z M0.995509091,13.7513091 L13.2300182,20.8149091 C13.1981818,20.5476364 13.1818182,20.2758182 13.1818182,20 L13.1818182,1.19229091 C7.43245455,3.27698182 2.91076364,7.92290909 0.995509091,13.7513091 Z M20,40 C15.0961818,40 10.6045818,38.2350909 7.12570909,35.3058182 L23.2943636,25.9709091 C23.5723636,25.8172727 23.8383636,25.6447273 24.0909091,25.4550909 L24.0909091,39.5812727 C22.7703636,39.8558182 21.402,40 20,40 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "retail" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Retail+CPG"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Retail+CPG",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("polygon", {
        id: "Icon",
        fill: "#2C94B1",
        points: "16.1507368 1.63854193 9.93222787 14.1007522 30.0681926 14.1007522 23.8496837 1.63854193 27.1200044 0 34.1560935 14.1007522 40 14.1007522 34.8062086 37 5.19380965 37 0 14.1007522 5.84421734 14.1007522 12.8803064 0"
    }))) : null, keyword === "smile" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/HR"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/HR",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M20,40 C31.0456364,40 40,31.0456364 40,20 C40,8.95430909 31.0456364,0 20,0 C8.95430909,0 0,8.95430909 0,20 C0,31.0456364 8.95430909,40 20,40 Z M20,28.1818182 C15.9833818,28.1818182 12.7272727,24.9256364 12.7272727,20.9090909 L9.09090909,20.9090909 C9.09090909,26.934 13.9750727,31.8181818 20,31.8181818 C26.0249091,31.8181818 30.9090909,26.934 30.9090909,20.9090909 L27.2727273,20.9090909 C27.2727273,24.9256364 24.0165455,28.1818182 20,28.1818182 Z M11.8181818,16.3636364 L11.8181818,10.9090909 L15.4545455,10.9090909 L15.4545455,16.3636364 L11.8181818,16.3636364 Z M24.5454545,10.9090909 L24.5454545,16.3636364 L28.1818182,16.3636364 L28.1818182,10.9090909 L24.5454545,10.9090909 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "science" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Life Sciences"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Life-Sciences",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("polygon", {
        id: "Icon",
        fill: "#2C94B1",
        points: "28.6363636 19.0585455 28.6363636 0 33.1818182 0 33.1818182 6.81818182 40 6.81818182 40 11.3636364 33.1818182 11.3636364 33.1818182 20 33.1818182 20.9414545 32.5161818 21.6070909 21.6070909 32.5161818 20.9414545 33.1818182 20 33.1818182 13.6363636 33.1818182 13.6363636 28.6363636 19.0585455 28.6363636 22.2403636 25.4545455 14.5454545 17.7596364 11.3636364 20.9414545 11.3636364 40 6.81818182 40 6.81818182 33.1818182 0 33.1818182 0 28.6363636 6.81818182 28.6363636 6.81818182 20 6.81818182 19.0585455 7.48385455 18.3929091 18.3929091 7.48385455 19.0585455 6.81818182 20 6.81818182 26.3636364 6.81818182 26.3636364 11.3636364 20.9414545 11.3636364 17.7596364 14.5454545 25.4545455 22.2403636"
    }))) : null, keyword === "supply" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "38px",
        height: "40px",
        viewBox: "0 0 38 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Supply Chain"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Supply-Chain",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M2.60909929,0 L6.8043106,4.1556481 L7.34216573,4.68843143 L7.34216573,5.44209076 L7.34216573,29.3983521 C8.90565072,29.9465407 10.14476,31.1749634 10.6974429,32.7247694 L33.0321484,32.7247694 L33.7922548,32.7247694 L34.3297613,33.2574981 L38,36.8951135 L35.4047742,39.4672712 L32.272042,36.3623847 L10.6974429,36.3623847 C9.9416857,38.4816594 7.90242767,40 5.50535807,40 C2.46484056,40 0,37.5571594 0,34.543577 C0,32.1673048 1.53278344,30.1457001 3.67192702,29.3970789 L3.67192702,6.19575008 L0.0145524965,2.57288531 L2.60909929,0 Z M11.469496,9.53502637 L32.5733686,9.53502637 L32.5733686,28.6324522 L11.469496,28.6324522 L11.469496,9.53502637 Z M22.9389919,24.085433 L28.44435,24.085433 L28.44435,21.3572216 L22.9389919,21.3572216 L22.9389919,24.085433 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "tie" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Public Sector"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Public-Sector",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M12.106882,0 L27.8931554,0 L23.6782623,8.27243899 L16.3218688,8.27243899 L12.106882,0 Z M15.8247362,11.0299187 L9,30.2848476 L20.0000656,40 L31,30.2848476 L24.175245,11.0299187 L15.8247362,11.0299187 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "telecommunications" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Telecommunications"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Telecommunications",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M5.44095897,9.76048988 C13.7126211,1.59498051 27.1236935,1.59498051 35.3953003,9.76048988 L38,7.18919888 C28.2897487,-2.39639963 12.5464368,-2.39639963 2.83624085,7.18919888 L5.44095897,9.76048988 Z M30.1862692,14.9030901 C24.7915829,9.5777626 16.0453394,9.5777626 10.6507452,14.9030901 L8.04602704,12.3317991 C14.8791368,5.58638064 25.9578224,5.58638064 32.790969,12.3317991 L30.1862692,14.9030901 Z M20.4181849,15.4545446 C16.1206698,15.4545446 12.451178,18.0949083 10.9782389,21.8209085 C5.99886421,21.9419994 2,25.964545 2,30.9090906 C2,35.929818 6.12305803,40 11.2090924,40 L28.7063681,40 C32.7751293,40 36.073642,36.7438181 36.073642,32.7272725 C36.073642,29.337636 33.7244026,26.4894541 30.545608,25.6830904 C30.5472657,25.6070904 30.5481866,25.5309086 30.5481866,25.4545446 C30.5481866,19.9316357 26.0128927,15.4545446 20.4181849,15.4545446 Z",
        id: "Icon",
        fill: "#2C94B1"
    }))) : null, keyword === "transport" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Travel+Transport"), /*#__PURE__*/ React.createElement("g", {
        id: "Icon/Travel+Transport",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("rect", {
        id: "Clear-Space",
        x: "0",
        y: "0",
        width: "40",
        height: "40"
    }), /*#__PURE__*/ React.createElement("path", {
        d: "M31.1627907,4.13793103 L8.8372093,4.13793103 L8.8372093,0 L5.11627907,0 L5.11627907,4.13793103 L0,4.13793103 L0,40 L40,40 L40,4.13793103 L34.8837209,4.13793103 L34.8837209,0 L31.1627907,0 L31.1627907,4.13793103 Z M15.7740465,13.3612138 L15.0429581,11.556046 L11.5885767,12.9230713 L13.0111256,16.4356046 L13.702586,18.1428966 L15.429786,17.4594943 L19.5722791,15.8201195 L19.903814,19.3173333 L23.6083721,18.9741609 L23.1743256,14.3946299 L27.7693023,12.5761839 L26.3864186,9.16150805 L15.7740465,13.3612138 Z M17.2093023,27.1264368 L6.04651163,27.1264368 L6.04651163,24.3678161 L17.2093023,24.3678161 L17.2093023,27.1264368 Z M6.04651163,34.4827586 L17.2093023,34.4827586 L17.2093023,31.7241379 L6.04651163,31.7241379 L6.04651163,34.4827586 Z M33.9534884,27.1264368 L22.7906977,27.1264368 L22.7906977,24.3678161 L33.9534884,24.3678161 L33.9534884,27.1264368 Z M22.7906977,34.4827586 L33.9534884,34.4827586 L33.9534884,31.7241379 L22.7906977,31.7241379 L22.7906977,34.4827586 Z",
        id: "Shape",
        fill: "#2C94B1"
    }))) : null, keyword === "upskill" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "40px",
        height: "40px",
        viewBox: "0 0 40 40",
        version: "1.1",
        className: className
    }, /*#__PURE__*/ React.createElement("title", null, "Icon/Self-sufficient"), /*#__PURE__*/ React.createElement("g", {
        id: "Desktop",
        stroke: "none",
        strokeWidth: "1",
        fill: "none",
        fillRule: "evenodd"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Features-Module:-Upskill-Feature-Active",
        transform: "translate(-75.000000, -817.000000)",
        fill: "#2C94B1"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "Benefits-Tabber",
        transform: "translate(75.000000, 240.000000)"
    }, /*#__PURE__*/ React.createElement("g", {
        id: "icon-self-sufficient_teal",
        transform: "translate(0.000000, 577.000000)"
    }, /*#__PURE__*/ React.createElement("path", {
        d: "M5.45454545,10.9090909 C8.467,10.9090909 10.9090909,8.467 10.9090909,5.45454545 C10.9090909,2.44209091 8.467,0 5.45454545,0 C2.44209091,0 0,2.44209091 0,5.45454545 C0,8.467 2.44209091,10.9090909 5.45454545,10.9090909 Z M20,25.4545455 C23.0125455,25.4545455 25.4545455,23.0125455 25.4545455,20 C25.4545455,16.9874545 23.0125455,14.5454545 20,14.5454545 C16.9874545,14.5454545 14.5454545,16.9874545 14.5454545,20 C14.5454545,23.0125455 16.9874545,25.4545455 20,25.4545455 Z M40,34.5454545 C40,37.558 37.558,40 34.5454545,40 C31.5329091,40 29.0909091,37.558 29.0909091,34.5454545 C29.0909091,31.5329091 31.5329091,29.0909091 34.5454545,29.0909091 C37.558,29.0909091 40,31.5329091 40,34.5454545 Z M40,7.27272727 L13.4336182,7.27272727 C13.5663091,6.68798182 13.6363636,6.07943636 13.6363636,5.45454545 C13.6363636,4.82965455 13.5663091,4.22110909 13.4336182,3.63636364 L40,3.63636364 L40,7.27272727 Z M40,21.8181818 L27.9790909,21.8181818 C28.1118182,21.2334545 28.1818182,20.6249091 28.1818182,20 C28.1818182,19.3750909 28.1118182,18.7665455 27.9790909,18.1818182 L40,18.1818182 L40,21.8181818 Z M11.8181818,20 C11.8181818,20.6249091 11.8882364,21.2334545 12.0209273,21.8181818 L0,21.8181818 L0,18.1818182 L12.0209273,18.1818182 C11.8882364,18.7665455 11.8181818,19.3750909 11.8181818,20 Z M26.3636364,34.5454545 C26.3636364,33.9205455 26.4336364,33.312 26.5663636,32.7272727 L0,32.7272727 L0,36.3636364 L26.5663636,36.3636364 C26.4336364,35.7789091 26.3636364,35.1703636 26.3636364,34.5454545 Z",
        id: "Shape"
    })))))) : null, keyword === "warning" ? /*#__PURE__*/ React.createElement("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        fill: "#2C94B1",
        version: "1.1",
        id: "Layer_1",
        viewBox: "0 0 512 512",
        xmlSpace: "preserve",
        className: className,
        width: "40px",
        height: "40px"
    }, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("path", {
        d: "M256,34.297L0,477.703h512L256,34.297z M256,94.301l204.036,353.4H51.965L256,94.301z"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("circle", {
        cx: "256",
        cy: "397.7",
        r: "15.001"
    }))), /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("g", null, /*#__PURE__*/ React.createElement("rect", {
        x: "240.998",
        y: "192.685",
        width: "30.002",
        height: "160.012"
    })))) : null);
}
